import { render, staticRenderFns } from "./RestaurantDetailPage.vue?vue&type=template&id=a79fcfce&scoped=true"
import script from "./RestaurantDetailPage.vue?vue&type=script&lang=js"
export * from "./RestaurantDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79fcfce",
  null
  
)

export default component.exports